import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const NAV_LINKS = [
  { href: '/#how-it-works', label: 'How It Works' },
  { href: '/#markets', label: 'Markets', testId: 'nav-markets' },
  { href: '/#who-we-help', label: 'Who We Help' },
  { href: '/#forms', label: 'Contact' },
];

const HeaderLogo = () => (
  <Link to="/" className="flex items-center gap-2">
    <div className="w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center">
      <Home className="w-5 h-5 text-white" />
    </div>
    <span className="text-lg font-bold text-slate-900">DreamHousesUSA</span>
  </Link>
);

const DesktopNav = () => (
  <nav className="hidden md:flex items-center gap-8">
    {NAV_LINKS.map((l) => (
      <a
        key={l.label}
        href={l.href}
        data-testid={l.testId}
        className="text-slate-600 hover:text-emerald-600 font-medium transition-colors"
      >
        {l.label}
      </a>
    ))}
  </nav>
);

const HeaderCtas = ({ onClick, vertical = false }) => (
  <div className={vertical ? 'flex flex-col gap-3 pt-4' : 'hidden md:flex items-center gap-3'}>
    <Button
      variant="outline"
      className={`border-emerald-600 text-emerald-600 hover:bg-emerald-50 ${vertical ? 'w-full' : ''}`}
      onClick={onClick}
    >
      Sell Property
    </Button>
    <Button
      className={`bg-emerald-600 hover:bg-emerald-700 text-white ${vertical ? 'w-full' : ''}`}
      onClick={onClick}
    >
      Join Buyer List
    </Button>
  </div>
);

const MobileMenu = ({ onClose, onCtaClick }) => (
  <div className="md:hidden py-4 border-t border-slate-100">
    <nav className="flex flex-col gap-4">
      {NAV_LINKS.map((l) => (
        <a
          key={l.label}
          href={l.href}
          onClick={onClose}
          className="text-slate-600 hover:text-emerald-600 font-medium transition-colors py-2"
        >
          {l.label}
        </a>
      ))}
      <HeaderCtas onClick={onCtaClick} vertical />
    </nav>
  </div>
);

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const scrollToForms = () => {
    const el = document.getElementById('forms');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#forms';
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-slate-100">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <HeaderLogo />
          <DesktopNav />
          <HeaderCtas onClick={scrollToForms} />
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen((open) => !open)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6 text-slate-900" /> : <Menu className="w-6 h-6 text-slate-900" />}
          </button>
        </div>
        {mobileMenuOpen && (
          <MobileMenu onClose={() => setMobileMenuOpen(false)} onCtaClick={scrollToForms} />
        )}
      </div>
    </header>
  );
};

export default Header;
